import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Bold } from '@sorare/core/src/atoms/typography/Bold';
import { useTimeLeft } from '@sorare/core/src/hooks/useTimeLeft';

const Root = styled(SBHorizontal)`
  padding: var(--unit);
  background-color: var(--c-nd-50);
`;

type Props = { newRecruitsCount: number; endDate: Date };
export const NewRecruitHeader = ({ newRecruitsCount, endDate }: Props) => {
  const { elements } = useTimeLeft(endDate);

  return (
    <Root>
      <LabelM>
        <FormattedMessage
          id="NewRecruitHeader.newRecruits"
          defaultMessage="{newRecruitsCount, plural, one {New Recruit} other {New Recruits}} ({newRecruitsCount})"
          values={{ newRecruitsCount }}
        />
      </LabelM>
      <LabelM>
        <FormattedMessage
          id="NewRecruitHeader.joiningIn"
          defaultMessage="Joining the squad in <b>{days}d</b>"
          values={{ b: Bold, days: elements?.days }}
        />
      </LabelM>
    </Root>
  );
};
